import { gsap } from '../vendor/gsap';
import { ScrollTrigger } from '../vendor/gsap/ScrollTrigger';
import addTitleToTimeline from '../lib/add-title-to-timeline';
import transparentBeforeAnimation from '../lib/transparent-before-animation';

gsap.registerPlugin(ScrollTrigger);

const moduleSelector = '.section-title';
// eslint-disable-next-line no-unused-vars
const moduleCallBack = (moduleElement, query, queryAll) => {
    const parentSectionElement = moduleElement.parentElement.closest('section');
    const parentBlockElement = moduleElement.parentElement.closest('div');
    let onAnimationCompleteCallbacksSection = [];
    const timelineSection = gsap.timeline({
        paused: true,
        scrollTrigger: {
            trigger: parentSectionElement,
            start: 'top 100%',
        },
        onComplete() {
            onAnimationCompleteCallbacksSection.forEach((cb) => cb());
        },
    });
    let onAnimationCompleteCallbacksBlock = [];
    const timelineBlock = gsap.timeline({
        paused: true,
        scrollTrigger: {
            trigger: parentBlockElement,
            start: 'top 100%',
        },
        onComplete() {
            onAnimationCompleteCallbacksBlock.forEach((cb) => cb());
        },
    });
    if (moduleElement.classList.contains('inner-trigger')) {
        transparentBeforeAnimation(moduleElement, timelineBlock);
        onAnimationCompleteCallbacksBlock = addTitleToTimeline(moduleElement, timelineBlock, '+=0');
    } else {
        transparentBeforeAnimation(moduleElement, timelineSection);
        onAnimationCompleteCallbacksSection = addTitleToTimeline(moduleElement, timelineSection, '+=0');
    }
};

export { moduleSelector, moduleCallBack };
